import { useSessionStorage } from 'usehooks-ts';

import { sessionPrevUrlKey } from '@/consts/localStorageKeys';

// 명칭은 prevUrl 이지만, 현재 페이지의 url을 저장 (auth 제외) -> redirect를 위해 사용
export const usePrevUrl = () => {
  return useSessionStorage(sessionPrevUrlKey, '');
};
